module.exports = __webpack_public_path__ + "img/importantRisk.da663308.png";